// extracted by mini-css-extract-plugin
export default {"container":"Sk-z","blurb":"Tk-z","links":"Uk-z"};